const Title = () => (
    <section id="title">
        <div className="container-fluid pt-4 pb-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-5"><b>LAST CHANCE: Lock In Your Progress And Save BIG</b></h3>
                    <p className="fw-light">⚠️ Please don’t hit the “Back” button. It could interrupt your order!</p>
                </div>
            </div>
        </div>
    </section>
);

export default Title;